import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5bda8e36&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=5bda8e36&lang=scss&scoped=true&"
import style1 from "./404.vue?vue&type=style&index=1&id=5bda8e36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda8e36",
  null
  
)

export default component.exports